import { MDBCol, MDBRow } from 'mdb-react-ui-kit';
import React, { useEffect, useState } from 'react'
import '../../../Pages/Css/modalesMaestros.css'

const FormModalCreateInstalador = ({ onSave, initialData }) => {
  const [cc, setCc] = useState('');               // Identificación
  const [nombre, setNombre] = useState('');
  const [telefono, setTelefono] = useState('');   // Teléfono
  const [instaladores, setInstaladores] = useState([]);
  const [idEdit, setIdEdit] = useState(-1);

  const submit = e => {
    e.preventDefault();
    if (!nombre.trim() || !cc.trim() || !telefono.trim()) {
      // Puedes usar una alerta aquí si tienes una librería como Swal
      alert('Debe completar todos los campos: Nombre, Identificación y Teléfono');
      return;
    }
    onSave({ nombre, cc, telefono });
  };

  useEffect(() => {
    if (initialData) {
      console.log('Cargando datos iniciales:', initialData)
      setNombre(initialData.nombre || '')
      setCc(initialData.cc || '')
      setTelefono(initialData.telefono || '')
    }
  }, [initialData])

  return (
    <>

      <MDBRow className="mb-3 g-0">
        <MDBCol size="12">
          <label className="form-label">Identificación (C.C.)</label>
          <input
            type="text"
            className="form-control"
            placeholder="Documento de identidad"
            value={cc}
            onChange={e => setCc(e.target.value)}
            style={{ boxSizing: 'border-box' }}
          />
        </MDBCol>
      </MDBRow>

      <MDBRow className="mb-3 g-0">
        <MDBCol size="12">
          <label className="form-label">Nombre</label>
          <input
            type="text"
            className="form-control"
            placeholder="Nombre completo"
            value={nombre}
            onChange={e => setNombre(e.target.value)}
            style={{ boxSizing: 'border-box' }}
          />
        </MDBCol>
      </MDBRow>

      <MDBRow className="mb-3 g-0">
        <MDBCol size="12">
          <label className="form-label">Teléfono</label>
          <input
            type="text"
            className="form-control"
            placeholder="Número de teléfono"
            value={telefono}
            onChange={e => setTelefono(e.target.value)}
            style={{ boxSizing: 'border-box' }}
          />
        </MDBCol>
      </MDBRow>
      <div className="d-flex justify-content-end">
        <button className='btn-primary-modals-maestros' onClick={submit}>
          Guardar
        </button>
      </div>
    </>
  )
}

export default FormModalCreateInstalador
